export default function EquipmentController(
	$scope,
	$window,
	$rootScope,
	$state,
	$stateParams,
	$location,
	$filter,
	equipmentRepository,
	mobileService
) {
    'ngInject';

	//Timer Settings
	$scope.timerColour = '#3A6180';
	$scope.timerBgColour = '#DDDDDD';
	$scope.totalTime = 60; //in seconds
	$scope.timeElapsed = 0; //in milliseconds
	$scope.progress = 0.0;
	$scope.lastUpdated = new Date();
	$scope.timerPause = false;
	// holed the last equipments search (url has search param) on the map
	$scope.previousSearchURL = null;
	$scope.equipments = [];
	$scope.filters = {};

	$scope.state = $state;

	$scope.currentBounds = null; //THe last bounds of the equipment application so that the map can reset back to these bounds on going back from equipment detail

	$scope.isAssetSearchVisible = function() {
		return $state.current.name === 'equipment.map' || !mobileService.isMobile();
	};

	// in case user  refresh the browser the equipments object will destroy
	//so will use this method to get the equipment again based on search param in the sessionStorage
	$scope.getLostEquipmentBySearchParam = function() {
		var searchParam = $scope.parseurl($window.sessionStorage.getItem('mapLastSearchURL'));
		if (searchParam) {
			if (searchParam.nlat && searchParam.slat && searchParam.nlng && searchParam.slng) {
				if (searchParam.search) {
					equipmentRepository
						.getEquipmentSearch(searchParam.search + '*' /*just append this so that it will search on partial words*/, {
							since: 0,
							limit: 100
						})
						.then(
							function(response) {
								$scope.equipments = $filter('withoutNull')(response.data.hits);
							},
							function(reason) {
								console.log('Failed to get equipment from i3: ' + reason.status);

								///toastr.error('Failed to get equipment from i3: ' + reason.status);
							}
						);
				} else {
					var nw = {
						lat: searchParam.nlat,
						lng: searchParam.slng
					};
					var se = {
						lat: searchParam.slat,
						lng: searchParam.nlng
					};
					// we may need to pass q as search fillter
					equipmentRepository.getEquipmentWithinBounds(nw, se).then(
						function(response) {
							$scope.equipments = $filter('withoutNull')(response.data);
						},
						function(reason) {
							console.error('Failed to get equipment from i3: ' + reason.status);
						}
					);
				}
			}
		}
	}; //end getLostEquipmentBySearchParam

	//take url as string then parse it to get map search param as a json object
	$scope.parseurl = function(url) {
		if (url) {
			var index = url.indexOf('?');
			var pairs = url.slice(index + 1).split('&');
			var result = {};
			pairs.forEach(function(pair) {
				pair = pair.split('=');
				result[pair[0]] = pair[1];
			});
			return JSON.parse(JSON.stringify(result));
		}
		return null;
	};

	//Timer functions
	$scope.evalFunc = function() {
		return $scope.progress;
	}; //used to evaluate progress

	$scope.forceMapRefresh = function() {
		$rootScope.$broadcast('forceMapRefresh');
	};
}
